<template>
    <DxPopup
        :visible="visible"
        :hide-on-outside-click="true"
        :show-close-button="true"
        :width="800"
        :height="600"
        :title="$t('help.title')"
        @hiding="onHiding"
    >
        <div class="help-container">
            <div class="help-section">
                <h2>{{ $t('help.instructions.title') }}</h2>
                <div class="instructions">
                    <p>{{ $t('help.instructions.step1') }}</p>
                    <p>{{ $t('help.instructions.step2') }}</p>
                </div>
            </div>

            <div class="download-section">
                <h2>{{ $t('help.downloads.title') }}</h2>
                <div class="download-buttons">
                    <DxButton
                        icon="fa-solid fa-file-pdf"
                        text="Fichero de configuración ZIV Oscilos"
                        @click="descargarRegOscilo"
                        stylingMode="outlined"
                    />
                    <DxButton
                        icon="fa-solid fa-file-excel"
                        text="Fichero de configuración Siemens SIGRAM"
                        @click="descargarRegSigra"
                        stylingMode="outlined"
                    />
                </div>
            </div>
        </div>
    </DxPopup>
</template>

<script setup lang="ts">
import { DxButton, DxPopup } from 'devextreme-vue';

const props = defineProps<{
    visible: boolean
}>();

const emit = defineEmits<{
    (e: 'update:visible', value: boolean): void
}>();

function onHiding() {
    emit('update:visible', false);
}

function descargarRegOscilo() {
    window.location.href = 'https://oscillion-iberdrola.unatec.es/docs/asociar_oscilo.reg';
}

function descargarRegSigra() {
    window.location.href = 'https://oscillion-iberdrola.unatec.es/docs/asociar_sigra.reg';
}
</script>

<style scoped lang="scss">

.help-container {
    padding: 20px;

    .help-section {
        margin-bottom: 40px;

        h2 {
            color: var(--text-secondary-default);
            margin-bottom: 15px;
            font-size: 1.7rem;
            font-weight: 500;
        }

        .instructions {
            background: var(--background-secondary-default);
            padding: 20px;
            border-radius: 8px;

            p {
                margin-bottom: 10px;
                line-height: 1.5;
                color: #ffffff;
            }
        }
    }

    .download-section {
        h2 {
            color: var(--text-secondary-default);
            margin-bottom: 15px;
            font-size: 1.7rem;
            font-weight: 500;
        }

        .download-buttons {
            display: flex;
            gap: 15px;
        }
    }
}
</style> 